import { SessionProvider } from "@saas/auth/client";
import { AuthWrapper } from "@saas/shared/components/AuthWrapper";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSessionFn } from "~/server/auth";

export const Route = createFileRoute("/_auth")({
	beforeLoad: async ({ search }) => {
		const session = await getSessionFn();

		// Redirect authenticated users away from auth pages. An invitation link
		// opened while signed in (maybe as another email) goes to that
		// invitation, which offers to switch accounts, never to /app.
		if (session?.user) {
			const { invitationId } = search as { invitationId?: unknown };
			if (typeof invitationId === "string" && invitationId) {
				throw redirect({
					to: "/organization-invitation/$invitationId",
					params: { invitationId },
				});
			}
			throw redirect({ to: "/app" });
		}

		return { session };
	},
	component: AuthLayout,
});

function AuthLayout() {
	const { session } = Route.useRouteContext();

	return (
		<SessionProvider initialSession={session}>
			<AuthWrapper>
				<Outlet />
			</AuthWrapper>
		</SessionProvider>
	);
}
